import { ptBrCommonFieldsTranslations } from "../common";

export const channel = {
  name: "Canal |||| Canais",
  fields: {
    name: "Nome",
    type: "Tipo",
    isEnabled: "Habilitado",
    config: "Configuração",
    connectionStatus: "Status da Conexão",
    createdAt: ptBrCommonFieldsTranslations.createdAt,
    updatedAt: ptBrCommonFieldsTranslations.updatedAt,
  },
  types: {
    WHATSAPP: "WhatsApp",
    TELEGRAM: "Telegram",
    EMAIL: "E-mail",
    SMS: "SMS",
    WEBCHAT: "Webchat",
    INSTAGRAM: "Instagram",
    FACEBOOK: "Facebook",
    INTERNAL: "Interno",
    ZAPY: "Zapy",
    whatsapp: "WhatsApp",
    telegram: "Telegram",
    email: "E-mail",
    sms: "SMS",
    webchat: "Webchat",
    instagram: "Instagram",
    facebook: "Facebook",
    internal: "Interno",
    zapy: "Zapy",
    unknown: "Desconhecido",
    whatsapp_official: "WhatsApp Oficial",
  },
  tabs: {
    details: "Detalhes do Canal",
    connections: "Conexões do Canal",
    whatsapp: "WhatsApp",
  },
  filters: {
    type: "Tipo de canal",
    isEnabled: "Habilitado",
  },
  comingSoon: "Em breve",
  empty: {
    title: "Nenhum canal",
    subtitle: "Ainda não há canais configurados.",
    noConnections: "Nenhuma conexão disponível",
  },
  create: {
    title: "Criar Canal",
  },
  edit: {
    title: "Editar Canal",
  },
  wizard: {
    selectChannel: "Selecione um tipo de canal",
    selectChannelDescription: "Escolha o tipo de canal que deseja criar para começar a receber mensagens",
    createChannel: "Criar Canal",
    queueHelper: "Os tickets deste canal serão encaminhados para esta fila",
    types: {
      zapy: {
        title: "Zapy (WhatsApp)",
        description: "Conecte o WhatsApp do seu celular via Zapy para receber e responder mensagens",
      },
      telegram: {
        title: "Telegram",
        description: "Crie um bot no Telegram para interagir com clientes na plataforma",
      },
      email: {
        title: "E-mail",
        description: "Conecte sua caixa de entrada de e-mail para gerenciar e-mails como tickets",
      },
    },
    steps: {
      channelInfo: "Informações",
      botSetup: "Configurar Bot",
      provider: "Provedor",
      serverConfig: "Configuração",
      smtpSetup: "Configurar SMTP",
      imapSetup: "Configurar IMAP",
      finish: "Concluído",
    },
    errors: {
      nameRequired: "Nome do canal é obrigatório",
      emailRequired: "E-mail é obrigatório",
      invalidEmail: "Insira um endereço de e-mail válido",
      botTokenRequired: "Token do bot é obrigatório",
      smtpAddressRequired: "Endereço do servidor SMTP é obrigatório",
      smtpLoginRequired: "Login SMTP é obrigatório",
      smtpPasswordRequired: "Senha SMTP é obrigatória",
      imapAddressRequired: "Endereço do servidor IMAP é obrigatório",
      imapLoginRequired: "Login IMAP é obrigatório",
      imapPasswordRequired: "Senha IMAP é obrigatória",
      createFailed: "Erro ao criar canal",
      fillRequired: "Preencha os campos obrigatórios",
      queueRequired: "Fila é obrigatória",
    },
    success: {
      channelCreated: "Canal criado com sucesso",
    },
    zapy: {
      title: "Criar Canal Zapy",
      subtitle: "Conecte o WhatsApp do seu celular via Zapy",
      instructions: "Após criar o canal, você poderá vincular seu número de WhatsApp escaneando um QR Code pelo celular.",
      namePlaceholder: "ex: Suporte WhatsApp",
      nameHelper: "Um nome para identificar esta conexão Zapy",
      successTitle: "Canal Criado com Sucesso!",
      successMessage: "Seu canal Zapy foi criado. Agora você precisa vincular seu número de WhatsApp escaneando o QR Code pelo celular.",
      goToChannel: "Ir para o Canal e Conectar",
    },
    telegram: {
      title: "Criar Canal Telegram",
      subtitle: "Conecte seu bot Telegram",
      step1Description: "Primeiro, dê um nome ao seu canal para identificá-lo no sistema.",
      namePlaceholder: "ex: Bot de Suporte",
      nameHelper: "Um nome para identificar este bot Telegram",
      howToGetToken: "Como obter um Token de Bot:",
      step1_open: "Abra o Telegram e busque por",
      step2_newbot: "Envie /newbot e siga as instruções para criar seu bot",
      step3_copy: "Copie o token fornecido pelo BotFather",
      botToken: "Token do Bot",
      tokenHelper: "O token que você recebeu do BotFather",
      successTitle: "Canal Criado com Sucesso!",
      successMessage: "Seu bot Telegram foi conectado. Você já pode receber mensagens dos seus clientes.",
      goToChannel: "Ir para o Canal",
    },
    email: {
      title: "Criar Canal de E-mail",
      subtitle: "Conecte sua caixa de entrada de e-mail",
      step1Description: "Insira as informações básicas do seu canal de e-mail.",
      namePlaceholder: "ex: E-mail de Suporte",
      nameHelper: "Um nome para identificar este canal de e-mail",
      emailAddress: "Endereço de E-mail",
      replyToDomain: "Domínio Reply-To",
      replyToDomainHelper: "Domínio para endereços de resposta (opcional)",
      selectProvider: "Selecione seu provedor de e-mail",
      selectProviderDescription: "Escolha o provedor para preencher automaticamente as configurações do servidor",
      providerGmail: "Gmail",
      providerGmailDesc: "Contas Google (Gmail, Google Workspace)",
      providerOutlook: "Outlook / Microsoft 365",
      providerOutlookDesc: "Microsoft 365, Outlook.com, Hotmail",
      providerOther: "Outro provedor",
      providerOtherDesc: "Configuração manual do servidor IMAP e SMTP",
      inboundSection: "Recebimento (IMAP)",
      outboundSection: "Envio (SMTP)",
      serverConfigDescription: "Configure os servidores de entrada e saída de e-mail. As configurações foram preenchidas com base no provedor selecionado.",
      serverConfigDescriptionManual: "Configure manualmente os servidores de entrada e saída de e-mail.",
      smtpDescription: "As configurações SMTP são usadas para enviar e-mails. Configure seu servidor de e-mail de saída.",
      enableSmtp: "Habilitar SMTP (Envio)",
      smtpAddress: "Servidor SMTP",
      smtpPort: "Porta",
      smtpLogin: "Usuário",
      smtpPassword: "Senha",
      securitySettings: "Segurança",
      starttlsHelp: "Porta 587: STARTTLS (atualiza para TLS)",
      sslHelp: "Porta 465: SSL/TLS (criptografado desde o início)",
      smtpSelfSignedCert: "Aceitar certificados auto-assinados",
      smtpSelfSignedCertHelp: "Habilite apenas se o servidor de e-mail usa certificado auto-assinado ou não confiável.",
      imapDescription: "As configurações IMAP são usadas para receber e-mails. Isto é opcional - você também pode usar encaminhamento de e-mail.",
      enableImap: "Habilitar IMAP (Recebimento)",
      imapAddress: "Servidor IMAP",
      imapPort: "Porta",
      imapLogin: "Usuário",
      imapPassword: "Senha",
      imapSsl: "Habilitar SSL/TLS",
      usernameHelper: "Geralmente é o endereço de e-mail completo",
      passwordHelper: "Para Gmail ou Outlook, use uma Senha de App",
      appPasswordTooltip: "Senhas de App são senhas específicas geradas nas configurações de segurança do seu provedor de e-mail. Elas são necessárias quando a autenticação em dois fatores está ativada.",
      noProtocolWarning: "Nenhum servidor de e-mail configurado",
      noProtocolWarningDetail: "Sem IMAP, e-mails recebidos não serão importados. Sem SMTP, e-mails não poderão ser enviados pela plataforma.",
      testConnection: "Testar Conexão",
      testingConnection: "Testando...",
      testConnectionSuccess: "Conexão verificada com sucesso!",
      testConnectionFailed: "Falha na verificação da conexão",
      testConnectionNote: "Você pode testar novamente nas configurações do canal",
      smtpVerified: "SMTP verificado",
      imapVerified: "IMAP verificado",
      smtpNotVerified: "SMTP não verificado",
      imapNotVerified: "IMAP não verificado",
      configSummary: "Resumo da configuração",
      imapConfigured: "IMAP configurado",
      smtpConfigured: "SMTP configurado",
      notConfigured: "Não configurado",
      successTitle: "Canal de E-mail Criado com Sucesso!",
      successMessage: "Seu canal de e-mail foi configurado. Você já pode receber e enviar e-mails através deste canal.",
      goToChannel: "Ir para o Canal",
    },
  },
  connection: {
    connected: "Conectado",
    disconnected: "Desconectado",
  },
  zapy: {
    title: "Conexão WhatsApp",
    status: "Status",
    noConnection: "Sem conexão",
    noConnections: "Nenhuma conexão WhatsApp configurada",
    scanQRCode: "Escanear QR Code",
    scanQRTitle: "Escanear QR Code",
    scanQRInstructions: "Abra o WhatsApp no seu telefone, vá em Configurações > Dispositivos Conectados > Conectar Dispositivo e escaneie este QR Code.",
    refreshQR: "Atualizar QR",
    restart: "Reiniciar",
    disconnect: "Desconectar",
    confirmRestart: "Reiniciar Conexão?",
    confirmLogout: "Desconectar WhatsApp?",
    restartWarning: "Isso vai reiniciar a conexão WhatsApp. Você pode precisar escanear o QR Code novamente.",
    logoutWarning: "Isso vai desconectar seu WhatsApp. Você precisará escanear o QR Code novamente para reconectar.",
    profileName: "Perfil",
    phoneNumber: "Telefone",
    statuses: {
      connected: "Conectado",
      disconnected: "Desconectado",
      pending_qr_code_scan: "Aguardando QR",
      connecting: "Conectando",
      error: "Erro",
      not_found: "Não encontrado",
      created: "Criado",
      qr_timeout: "QR Code Expirado",
    },
    notifications: {
      statusFetchFailed: "Erro ao buscar status",
      qrFetchFailed: "Erro ao buscar QR Code",
      restarted: "Conexão reiniciada",
      restartFailed: "Erro ao reiniciar conexão",
      disconnected: "WhatsApp desconectado",
      logoutFailed: "Erro ao desconectar",
    },
  },
  telegram: {
    title: "Conexão Telegram",
    status: "Status",
    noConnection: "Sem conexão",
    noConnections: "Nenhuma conexão Telegram configurada",
    connect: "Conectar Bot",
    disconnect: "Desconectar",
    confirmDisconnect: "Desconectar Bot Telegram?",
    disconnectWarning: "Isso vai desconectar o bot Telegram. Novas mensagens não serão recebidas até reconectar.",
    botUsername: "Bot",
    webhookUrl: "Webhook URL",
    setupInstructions: "Clique em 'Conectar Bot' para registrar o webhook e começar a receber mensagens do Telegram.",
    statuses: {
      connected: "Conectado",
      disconnected: "Desconectado",
    },
    notifications: {
      connected: "Bot Telegram conectado com sucesso",
      disconnected: "Bot Telegram desconectado",
      setupFailed: "Erro ao conectar bot Telegram",
      disconnectFailed: "Erro ao desconectar bot Telegram",
    },
    setup: {
      title: "Adicionar Bot Telegram",
      instructions: "Para conectar um bot Telegram, você precisa criar um bot no @BotFather e copiar o token.",
      step1: "Abra o Telegram e busque por",
      step2: "Envie /newbot e siga as instruções para criar seu bot",
      step3: "Copie o token do bot e cole abaixo",
      connectionName: "Nome da conexão",
      botToken: "Token do Bot",
      tokenHelper: "O token é fornecido pelo @BotFather ao criar o bot",
      addBot: "Adicionar Bot",
      creating: "Criando...",
      connecting: "Conectando...",
    },
    errors: {
      tokenRequired: "O token do bot é obrigatório",
      invalidToken: "Token inválido. O token deve estar no formato 123456789:ABCdef...",
      createFailed: "Erro ao criar conexão. Verifique se o token está correto.",
    },
    botInfo: {
      name: "Nome",
      username: "Username",
      canJoinGroups: "Grupos",
      canReadGroupMessages: "Ler mensagens de grupo",
      webhookError: "Erro no Webhook",
      webhookErrorDescription: "O Telegram está tentando entregar mensagens, mas o servidor retornou um erro: %{error}",
    },
    groupSetup: {
      title: "Configuração para Grupos",
      description: "Para usar o bot em grupos do Telegram, siga os passos abaixo no @BotFather.",
      allowGroupsTitle: "1. Permitir que o bot entre em grupos",
      allowGroups: {
        step1: "Abra o Telegram e acesse o @BotFather",
        step2: "Envie /mybots → Selecione %{botName} → Bot Settings → Allow Groups → Turn ON",
        step3: "Isso permite que o bot seja adicionado a grupos e supergrupos",
      },
      privacyTitle: "2. Desativar o Modo de Privacidade",
      privacy: {
        step1: "Ainda em Bot Settings do @BotFather:",
        step2: "Group Privacy → Turn OFF (para %{botName})",
      },
      readdBot: "Após alterar essas configurações, remova e adicione o bot novamente ao grupo para aplicar.",
      note: "Com o Modo de Privacidade ativo, o bot só recebe comandos (/), menções (@bot) e respostas às suas mensagens — mensagens normais de outros membros não chegam.",
      allConfigured: "Bot configurado corretamente para receber mensagens de grupos.",
    },
  },
  email: {
    setup: {
      title: "Configurar Canal de E-mail",
      description: "Configure um canal de e-mail para receber e enviar mensagens por e-mail.",
      steps: {
        basicInfo: "Informações Básicas",
        complete: "Concluído",
      },
      fields: {
        channelName: "Nome do Canal",
        email: "Endereço de E-mail",
        replyToDomain: "Domínio para Reply-To",
      },
      helpers: {
        channelName: "Um nome para identificar este canal (ex: Suporte, Vendas)",
        email: "O endereço de e-mail que receberá as mensagens (ex: suporte@empresa.com)",
        replyToDomain: "Domínio usado para gerar endereços de resposta (ex: tickets.empresa.com)",
      },
      validation: {
        nameRequired: "Nome do canal é obrigatório",
        emailRequired: "Endereço de e-mail é obrigatório",
        emailInvalid: "Endereço de e-mail inválido",
        domainRequired: "Domínio para Reply-To é obrigatório",
      },
      info: {
        imapSmtpLater: "Você poderá configurar IMAP e SMTP posteriormente nas configurações do canal.",
      },
      createChannel: "Criar Canal",
      error: "Erro ao criar canal de e-mail",
      success: {
        title: "Canal de E-mail Criado!",
        description: "Seu canal de e-mail foi criado com sucesso.",
        nextSteps: "Próximo passo: Configure as opções de IMAP e SMTP nas configurações do canal para habilitar envio e recebimento de e-mails.",
      },
    },
    imap: {
      title: "Configurações IMAP",
      subtitle: "Configure o servidor IMAP para receber e-mails diretamente.",
      note: "O IMAP permite que o sistema busque e-mails diretamente da sua caixa de entrada.",
      toggle: "Habilitar IMAP",
      toggleHelp: "Quando habilitado, o sistema buscará e-mails automaticamente do servidor IMAP.",
      address: "Endereço do Servidor IMAP",
      port: "Porta",
      login: "Login/Usuário",
      password: "Senha",
      enableSsl: "Habilitar SSL/TLS",
      save: "Salvar Configurações IMAP",
      saveSuccess: "Configurações IMAP salvas com sucesso",
      saveError: "Erro ao salvar configurações IMAP",
      validation: {
        addressRequired: "Endereço do servidor é obrigatório",
        portRequired: "Porta é obrigatória",
        loginRequired: "Login é obrigatório",
        passwordRequired: "Senha é obrigatória",
      },
    },
    smtp: {
      title: "Configurações SMTP",
      subtitle: "Configure o servidor SMTP para enviar e-mails.",
      toggle: "Habilitar SMTP",
      toggleHelp: "Quando habilitado, o sistema usará este servidor para enviar e-mails.",
      address: "Endereço do Servidor SMTP",
      port: "Porta",
      login: "Login/Usuário",
      password: "Senha",
      domain: "Domínio",
      domainHelp: "Domínio usado no comando HELO/EHLO",
      encryption: "Criptografia",
      openSslVerifyMode: "Modo de Verificação OpenSSL",
      authMechanism: "Mecanismo de Autenticação",
      save: "Salvar Configurações SMTP",
      saveSuccess: "Configurações SMTP salvas com sucesso",
      saveError: "Erro ao salvar configurações SMTP",
      validation: {
        addressRequired: "Endereço do servidor é obrigatório",
        portRequired: "Porta é obrigatória",
        loginRequired: "Login é obrigatório",
        passwordRequired: "Senha é obrigatória",
        domainRequired: "Domínio é obrigatório",
      },
    },
    config: {
      title: "Configuração de E-mail",
      notFound: "Conexão não encontrada",
      tabs: {
        imap: "IMAP (Recebimento)",
        smtp: "SMTP (Envio)",
      },
      imapStatus: "IMAP: %{status}",
      smtpStatus: "SMTP: %{status}",
      enabled: "Habilitado",
      disabled: "Desabilitado",
      noConfigWarning: "Nem IMAP nem SMTP estão configurados. Configure pelo menos um para usar este canal de e-mail.",
    },
  },
  settings: {
    title: "Configurações da Conexão",
    saveSuccess: "Configurações salvas com sucesso",
    saveError: "Erro ao salvar configurações",
    queueRequired: "Selecione uma fila antes de salvar",
    ticketMode: "Modo de Tickets",
    ticketModeHelp: "Configure como os tickets são criados para mensagens recebidas nesta conexão.",
    ticketModes: {
      auto: "Automático",
      autoHelp: "Cria tickets automaticamente para novas conversas",
      manual: "Manual",
      manualHelp: "Agentes criam tickets manualmente quando necessário",
      off: "Desabilitado",
      offHelp: "Modo apenas chat, sem criação de tickets",
    },
    defaultQueue: "Fila Padrão",
    defaultQueueHelp: "Selecione a fila para onde os tickets desta conexão serão encaminhados. Se não selecionada, será usada a fila padrão do sistema.",
    useDefaultQueue: "Usar fila padrão do sistema",
    groupMessages: "Mensagens de Grupo",
    groupMessagesHelp: "Configure como as mensagens de grupos do WhatsApp são tratadas.",
    ignoreGroupMessages: "Ignorar mensagens de grupos",
    notifyGroupMessages: "Receber mensagens de grupos (sem criar tickets)",
    ignoreGroupMessagesWarning: "Todas as mensagens de grupos serão ignoradas e não aparecerão no sistema.",
  },
};

export const channelConnection = {
  name: "Conexão de Canal |||| Conexões de Canal",
  fields: {
    identifier: "Identificador",
    displayName: "Nome de Exibição",
    isActive: "Ativo",
  },
};
